module.exports = __webpack_public_path__ + "static/media/promo_2024_july_aug_desktop_900.882ef821.jpg";